<div class="login-bg">
        <img
          *ngIf="(pageFragment > 0) && (pageFragment < 3)"
          (click)="goBack()"
          class="back-arrow cursor-pointer mt-5" src="assets/icons/arrow-left.svg" alt="">
        <!-- initial selection for student/teacher -->
        <div *ngIf="pageFragment == 0" class="initial-form pt-6 text-center w-36">
            <h1 class="text-40-600-130 text-c4">{{'Welcome to the Global Classroom!' | translate}}</h1>
            <p class="text-16-400-150 mt-4 text-c2">{{'Please select your role to proceed' | translate}}</p>
                <div class="radio-group mt-4">
                    <div
                        *ngFor="let option of roleOptions"
                        class="radio-option text-c4 text-18-500-133"
                        [class.selected]="selectedUserRole === option.value"
                        (click)="selectOption(option.value)">
                        {{ option.label | translate }}
                    </div>
                </div>
                <button
                (click)="submitRole()"
                [disabled]="!selectedUserRole"
                [ngClass]="{'op-50':!selectedUserRole}"
                class="continue-btn mt-4 py-3 text-16-600-150">{{'Continue' | translate}}</button>
                <div class="mt-4 text-16-400-121 text-c">
                  {{'Already have an account?' | translate}}
                  <span (click)="goToFragment(4)" class="ms-2 text-18-500-150 text-c4 c-pointer">
                    {{'Login here' | translate}}
                  </span>
                </div>
        </div>
        <!-- referral code submission -->
        <div *ngIf="pageFragment == 1" class="pt-6 text-center w-53">
            <h1 class="text-40-600-130 text-c4">{{'Learn about the sustainable goals to transform our world' | translate}}</h1>
            <p class="text-16-400-150 mt-4 text-c2">{{'Welcome to Global expedition gaming platform.' | translate}}
            </p>
                <div class="referral-form">
                    <p class="text-14-500-157 w-100 text-c5 d-flex">{{'Your referral code' | translate}}<span
                      style="color:red; font-size: 12px;">*</span></p>
                    <div class="password-container position-relative" [ngClass]="{'error-border':error}">
                        <input
                          [type]="isPasswordVisible ? 'text' : 'password'"
                          [placeholder]="('Referral code' | translate)"
                          [(ngModel)]="referralCode"
                          class="password-input w-100 text-16-400-150"
                          maxlength="80"
                          (keydown)="restrictSpace($event)"
                        />
                        <span class="referral_eyeicon" (click)="isPasswordVisible = !isPasswordVisible">
                          <img [src]="isPasswordVisible ? close : open " alt="arrow">
                        </span>
                        <!-- <img src="assets/icons/password-hidden.svg" alt=""> -->
                    </div>
                    <div *ngIf="referralCodeError && !referralCode" class="w-100 d-flex align-items-center gap-2">
                        <img src="assets/icons/error.svg" alt="">
                        <span class="text-danger text-12-400-183">{{'Wrong code, please try again' | translate}}</span>
                    </div>
                    <button
                    (click)="submitReferralCode()"
                    [disabled]="!referralCode"
                    [ngClass]="{'op-50':!referralCode}"
                    class="continue-btn mt-5 py-3 text-16-600-150">{{'Signup with referral code' | translate}}</button>
                    <div class="mt-4 text-16-400-121 text-c">
                      {{'Already have an account?' | translate}}
                      <span (click)="goToFragment(4); referralCodeError=''" class="ms-2 text-18-500-150 text-c4 c-pointer login-here">
                        {{'Login here' | translate}}
                      </span>
                    </div>
                </div>

        </div>
        <!-- referral code verfified & signup form -->
        <div *ngIf="pageFragment == 2" class="ptc-3 text-center w-53">
            <h1 class="text-32-600-125 text-c4">{{'Referral code verified!' | translate}}</h1>
            <p *ngIf="selectedUserRole == 1" class="text-14-400-157 mt-4 text-c2">{{"We recognized you as a student" | translate}}, {{referralData?.name}}. {{"Kindly provide us with your name and create a password to secure your account" | translate}}
            <p *ngIf="selectedUserRole == 2" class="text-14-400-157 mt-4 text-c2">{{"We recognized you as a teacher" | translate}}. {{"Kindly provide us with your name and create a password to secure your account" | translate}}
            </p>
            <form class="signup-form" [formGroup]="signUpForm">
                <div class="d-flex flex-column mb-4">
                  <label class="d-flex w-100 text-14-500-157 text-c2" for="name">{{'Username' | translate}}<span
                    style="color:red; font-size: 12px;">*</span></label>
                  <input class="text-16-400-150" id="name" formControlName="name" placeholder="{{'Enter your username' | translate}}" maxlength="80" (keydown)="restrictSpace($event)" />
                  <div class="d-flex gap-2 text-danger w-100 text-12-400-183" *ngIf="signUpForm.controls.name.hasError('required') && signUpForm.get('name')?.touched">
                    <img src="assets/icons/error.svg" alt="">
                    {{'Name is required' | translate}}
                  </div>
                </div>

                <div class="d-flex flex-column mb-4 position-relative">
                  <label class="d-flex w-100 text-14-500-157 text-c2" for="password">{{"Create new password" | translate}}<span
                    style="color:red; font-size: 12px;">*</span></label>
                  <input class="text-16-400-150" id="password" [type]="visible ?'text' : 'password'" formControlName="password" [placeholder]="('Enter your Password' | translate)" (keydown)="restrictSpaceOnPassword($event)" maxlength="30"/>
                  <div class="d-flex gap-2 text-danger w-100 text-12-400-183" *ngIf="signUpForm.get('password')?.invalid && signUpForm.get('password')?.touched">
                    <img src="assets/icons/error.svg" alt="">
                    {{"Password is required" | translate}}
                  </div>
                  <!-- <div *ngIf="signUpForm.get('password')?.errors?.minlength && signUpForm.get('password')?.touched && !signUpForm.get('password')?.invalid" class="d-flex gap-2 text-danger w-100 text-12-400-183">
                    <img src="assets/icons/error.svg" alt="">
                    {{'Password must be 8 - 15 characters'}}</div> -->
                  <span class="eyeicon" (click)="visible = !visible">
                    <img [src]="visible?  close : open " alt="arrow">
                  </span>
                </div>
                <div class="d-flex flex-column mb-4 position-relative">
                  <label class="d-flex w-100 text-14-500-157 text-c2" for="confirmPassword">{{"Confirm password" | translate}}<span
                    style="color:red; font-size: 12px;">*</span></label>
                  <input class="text-16-400-150" id="confirmPassword" [type]="visible1 ?'text' : 'password'" formControlName="confirmPassword" placeholder="Re-enter your password" (keydown)="restrictSpaceOnPassword($event)" maxlength="30" />
                  <div class="d-flex gap-2 text-danger w-100 text-12-400-183" *ngIf="signUpForm.get('confirmPassword')?.invalid && signUpForm.get('confirmPassword')?.touched">
                    <img src="assets/icons/error.svg" alt="">
                    {{"Password is required" | translate}}
                  </div>
                  <div class="d-flex gap-2 text-danger w-100 text-12-400-183" *ngIf="signUpForm.hasError('mismatch') && signUpForm.get('confirmPassword')?.valid">
                    <img src="assets/icons/error.svg" alt="">
                    {{"Passwords do not match. Please try again." | translate}}
                  </div>
                  <!-- <div *ngIf="signUpForm.get('confirmPassword')?.errors?.minlength && signUpForm.get('password')?.touched" class="d-flex gap-2 text-danger w-100 text-12-400-183">
                    <img src="assets/icons/error.svg" alt="">
                    {{'Password must be 8 - 15 characters'}}</div> -->
                  <span class="eyeicon" (click)="visible1 = !visible1">
                    <img [src]="visible1 ?  close : open " alt="arrow">
                  </span>
                </div>

                <div class="d-flex justify-content-center gap-2 text-danger w-100 text-12-400-183" *ngIf="signupError && !signUpForm.controls.email.value">
                  {{signupError | translate}}
                </div>

                <button (click)="submitSignUpForm()" [ngClass]="{'op-50':this.signUpForm.invalid}" [disabled]="this.signUpForm.invalid" class="continue-btn mt-4 text-16-600-150 py-3 c-pointer" type="submit">
                  {{"Create new account" | translate}}
                </button>
                <div class="mt-4 text-16-400-121 text-c">
                  {{'Already have an account?' | translate}}
                  <span (click)="goToFragment(4)" class="ms-2 text-18-500-150 text-c4 c-pointer">
                    {{'Login here' | translate}}
                  </span>
                </div>
            </form>
        </div>
        <!-- profile created -->
        <div *ngIf="pageFragment == 3" class="ptc-3 text-center w-36">
            <img src="assets/icons/check-blue.svg" alt="">
            <h1 class="text-32-600-125 mt-5">{{"Your profile is created" | translate}}</h1>
            <p class="text-16-400-150 mt-3 text-c2">{{"Kindly note down your username and password for future login" | translate}}</p>
            <div class="d-flex justify-content-center mt-5">
                <div class="profile-credentials d-flex gap-4">
                    <div class="d-flex flex-column gap-5 justify-content-between">
                     <span class="text-20-400-121 text-c2">{{'Username'| translate}}</span>
                     <span class="text-20-400-121 text-c2">{{'Password'|translate}}</span>
                    </div>
                    <div class="d-flex flex-column gap-5 justify-content-between">
                     <span class="text-24-500-112 text-c4">{{userDetails?.username || '-'}}</span>
                     <span class="text-24-500-112 text-c4">{{userDetails?.password || '-'}}</span>
                    </div>
                </div>
            </div>
            <button (click)="signUpNavigation()" class="mt-5 continue-btn2 text-16-600-150">{{'Continue' | translate}}</button>
        </div>
        <!-- login form -->
        <div *ngIf="pageFragment == 4" class="ptc-3 text-center w-53">
            <h1 class="text-40-600-130 text-c4">{{'Learn about the sustainable goals to transform our world' | translate}}</h1>
            <p class="text-16-400-150 mt-4 text-c2">{{'Welcome to Global expedition gaming platform.' | translate}}</p>
            <form class="login-form" [formGroup]="loginForm">
                <div class="d-flex flex-column mb-4">
                  <label class="d-flex w-100 text-14-500-157 text-c2" for="username">{{'Username' | translate}}<span
                    style="color:red; font-size: 12px;">*</span></label>
                  <input class="text-16-400-150" id="username" formControlName="username" placeholder="{{'Enter your username' | translate}}" maxlength="80" (keydown)="restrictSpace($event , 'login')"/>
                  <div *ngIf="loginForm.controls.username.invalid && loginForm.controls.username.touched" class="d-flex gap-2 text-danger w-100 text-12-400-183">
                      <img src="assets/icons/error.svg" alt="">
                      {{'Name is required' | translate}}
                  </div>
                </div>
                <div class="d-flex flex-column mb-4 position-relative">
                  <label class="d-flex w-100 text-14-500-157 text-c2" for="confirmPassword">{{'Password'|translate}}<span
                    style="color:red; font-size: 12px;">*</span></label>
                  <input class="text-16-400-150" id="confirmPassword" [type]="visible2 ?'text' : 'password'" formControlName="password" placeholder="{{'Password'|translate}}" (keydown)="restrictSpaceOnPassword($event , 'login')" maxlength="30" />
                  <div *ngIf="loginForm.controls.password.invalid && loginForm.controls.password.touched" class="d-flex gap-2 text-danger w-100 text-12-400-183" >
                    <img src="assets/icons/error.svg" alt="">
                    {{'Password is required' | translate}}
                    <!-- {{'Oops! That password is not correct' | translate}} -->
                  </div>
                  <span class="eyeicon" (click)="visible2 = !visible2">
                    <img [src]="visible2 ?  close : open " alt="arrow">
                  </span>
                </div>
                <div class="d-flex justify-content-center gap-2 text-danger w-100 text-12-400-183" *ngIf="loginError">
                  {{loginError | translate}}
                </div>
                <!-- <div class="text-16-400-121 text-c2 c-pointer">
                  <span [title]="'Please contact your group admin to reset your password.'">{{'Forgot your password?' | translate}}</span>
                  <img src="assets/icons/question.svg" alt="" matTooltipPosition="above" matTooltip ="{{'Please contact admin to reset password' | translate}}">
                </div> -->
                <!-- [disabled]="loginForm.invalid" -->
                <button
                  (click)="submitLoginForm()"
                  [ngClass]="{'op-50':this.loginForm.invalid}"
                  [disabled]="this.loginForm.invalid || loginForm.controls.username.value.trim() === ''  || loginForm.controls.password.value.trim() === '' "
                  class="continue-btn mt-4 text-16-600-150 py-3 c-pointer">{{'Login to your account' | translate}}</button>
                <div class="mt-4 text-c2 text-16-400-121 mb-flex">
                  {{'Don’t have an account?' | translate}}
                  <span (click)="goToFragment(0); clear(); loginError = '';" class="ms-2 text-18-500-150 text-c4 c-pointer">
                    {{'Signup using referral code' | translate}}</span>
                </div>
            </form>
        </div>
</div>
